import React, { Component } from 'react';
import { Grid, Form, Button } from 'semantic-ui-react';
import { getUserProfile, updateProfile } from '../../utils/rest';
import BreadcrumbCustom from '../../layout/BreadcrumbCustom';
import { NotificationManager } from 'react-notifications';
import * as SimpleReactValidator from 'simple-react-validator';
import Loading from '../Loading';
const initialState = {
    usrId: 0,
    usrUserName: "",
    usrFirstName: "",
    usrLastName: "",
    usrEmail: "",
    usrTitle: "",
    usrPhone: ""
}
class UpdateProfile extends Component {
    constructor(props) {
        super(props);
        this.validator = new SimpleReactValidator();
        this.state = {
            user: initialState,
            prevState: initialState,
            loading: true
        };
    }

    componentDidMount() {
        this.props.addItem("helpFile", "acct_update-profile.md");
        this.props.addItem("corporateSelect", false);
        this.getUser();
    }

    componentWillUnmount() {
        this.props.addItem("helpFile", null);
        this.props.addItem("corporateSelect", true);
    }

    getUser = () => {
        getUserProfile().then(response => {
            if (response !== null) {
                this.setState({
                    user: response,
                    prevState: response,
                    loading: false
                });
            }
        }).catch((error) => {
            this.setState({
                loading: false
            });
        });

    }

    handleChange = (e) => {
        this.setState({
            user: {
                ...this.state.user,
                [e.target.name]: e.target.value
            }
        })

    }

    onReset = () => {
        const prevState = this.state.prevState;
        this.setState({
            user: prevState
        })
    }

    handleSubmit = (e) => {
        e.preventDefault();
        if (this.validator.allValid()) {
            this.setState({
                loading: true
            });
            updateProfile(this.state.user).then(response => {
                if (response !== null) {
                    NotificationManager.success('Success', 'Profile updated successfully.');
                }
                this.setState({
                    loading: false
                });
            }).catch((error) => {
                this.setState({
                    loading: false
                });
            });
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }
    render() {
        if (this.state.loading) {
            return (
                <Loading />
            )
        }
        return (
            <div>
                <BreadcrumbCustom {...this.props} parent="My Account" child={[{ name: "Update Profile", url: null }]} />
                <Grid className="g-bkgd">
                    <Grid.Row>
                        <Grid.Column>
                            <Form className="small">
                                <Form.Group>
                                    <Form.Field width={5}>
                                        <Form.Input label='Login ID [Email]:' className="required" placeholder='Login ID [Email]:' value={this.state.user.usrUserName || ''} type="text" name="usrUserName" readOnly />
                                    </Form.Field>
                                    <Form.Field width={5}>
                                        <Form.Input label='First Name:' className="required" placeholder='First Name' value={this.state.user.usrFirstName || ''} type="text" name="usrFirstName" onChange={this.handleChange} />
                                        {this.validator.message('First Name', this.state.user.usrFirstName, 'required')}
                                    </Form.Field>
                                    <Form.Field width={5}>
                                        <Form.Input label='Last Name:' className="required" placeholder='Last Name' value={this.state.user.usrLastName || ''} type="text" name="usrLastName" onChange={this.handleChange} />
                                        {this.validator.message('Last Name', this.state.user.usrLastName, 'required')}
                                    </Form.Field>
                                </Form.Group>
                                <Form.Group>
                                    <Form.Field width={5}>
                                        <Form.Input label='Phone Number:' className="required" placeholder='Phone Number' value={this.state.user.usrPhone || ''} type="text" name="usrPhone" onChange={this.handleChange} maxLength="15" />
                                        {this.validator.message('Phone Number', this.state.user.usrPhone, 'required')}
                                    </Form.Field>
                                    <Form.Field width={2}>
                                        <Button.Group className="small push-down">
                                            <Button onClick={this.onReset}>{this.props.t("reset")}</Button>
                                            <Button.Or />
                                            <Button positive onClick={this.handleSubmit}>{this.props.t("submit")}</Button>
                                        </Button.Group>
                                    </Form.Field>
                                </Form.Group>
                            </Form>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div>
        );
    }
}
export default UpdateProfile;


// WEBPACK FOOTER //
// ./src/app/ui/administrations/UpdateProfile.js